// SPDX-FileCopyrightText: 2022-2026 Lablup Inc. All rights reserved.
// SPDX-License-Identifier: LicenseRef-Proprietary

export function logApiError(context: string, error: unknown): void {
  if (error instanceof Error) {
    console.warn(`[${context}] ${error.message}`, error);
  } else {
    console.warn(`[${context}]`, error);
  }
}
